import { getPluralForm } from './getPluralForm'

export function getPluralWord(number: number, locale: string = 'en', words: { one: string, few?: string, many?: string, other: string }) {
  const pluralForm = getPluralForm(number, locale);

  switch (pluralForm) {
    case 'one':
      return words.one;
    case 'few':
      return words.few || words.other;
    case 'many':
      return words.many || words.other;
    default:
      return words.other;
  }
}